import { SHARE_COSMETICS } from '../content/cosmetics';
import type { Save } from './save/schema';

/**
 * Telling a friend (owner, 2026-10-21): sharing the game's link from Settings. The first share
 * pays a one-time coin gift; the fifth gives the sharing cosmetics. The game cannot see who got the
 * link, so a share is counted when the share sheet says it went through (any five, no daily cap:
 * texting five friends at once counts five times).
 */
export const SHARE_GOAL = 5;
export const SHARE_GIFT_COINS = 50;

/** The link a share sends: a page that sends each friend to their own phone's store. */
export const SHARE_URL = 'https://playlawnmower.com/get';

/** What one share earned. */
export interface ShareReward {
  /** The first share's gift (0 after it). */
  coins: number;
  /** The cosmetics the goal gave, on the share that reached it. */
  items: string[];
}

/** Counts a share that went through and pays what it earned. */
export function recordShare(draft: Save): ShareReward {
  draft.shares += 1;
  const coins = draft.shares === 1 ? SHARE_GIFT_COINS : 0;
  draft.coins += coins;
  const items =
    draft.shares >= SHARE_GOAL
      ? SHARE_COSMETICS.filter((id) => !draft.cosmetics.owned.includes(id))
      : [];
  draft.cosmetics.owned.push(...items);
  return { coins, items };
}
